const parseISO_UTC = (s) => {
    if (s instanceof Date) {
        return new Date(Date.UTC(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate()));
    }
    const [y, m, d] = String(s).split("-").map(Number);
    return new Date(Date.UTC(y, m - 1, d));
};
const isoUTC = (d) => d.toISOString().slice(0, 10);

  // Suma 1 mes manteniendo día; si no existe (p.ej. 31->feb), clampa al último día del mes destino.
  const addOneMonthUTCClamped = (d) => {
    const y = d.getUTCFullYear();
    const m = d.getUTCMonth();
    const day = d.getUTCDate();
    const lastDayNextMonth = new Date(Date.UTC(y, m + 2, 0)).getUTCDate(); // 0 -> último día del mes (m+1)
    const targetDay = Math.min(day, lastDayNextMonth);
    return new Date(Date.UTC(y, m + 1, targetDay));
  };
  
  export function getMonthsBetweenDates(startDate, endDate) {
    const start = parseISO_UTC(startDate);
    const end = parseISO_UTC(endDate);
    if (start > end) return [];
  
    const out = [];
    let from = start;
  
    while (from <= end) {
      const nextFrom = addOneMonthUTCClamped(from);         // inicio del siguiente periodo (mismo día, mes+1)
      let to = new Date(nextFrom.getTime() - 24 * 60 * 60 * 1000); // -1 día
  
      if (to > end) to = end;            // cortar si se pasa
      out.push({ from: isoUTC(from), to: isoUTC(to) });
      if (to >= end) break;              // terminado
  
      // siguiente "from" = día siguiente al "to", siempre en UTC
      from = new Date(Date.UTC(to.getUTCFullYear(), to.getUTCMonth(), to.getUTCDate() + 1));
    }
  
    return out;
  }
  